const DEFAULT_ZOOM = 15

function create() {
  return {
    maps: null,
    map: null,
    selected: null,

    init() {
      import('@googlemaps/js-api-loader').then(({ Loader }) => {
        const loader = new Loader({ apiKey: window.tpn.keys.gmaps, libraries: ['places'] })

        loader.load().then(({ maps }) => {
          this.maps = maps

          if (this.$refs.map) {
            this.addMap()
            this.addMapMarkers()
          }
        })
      })
    },

    addMap() {
      const { maps } = this
      const mapMarkerPrimary = this.$el.querySelector('[data-map-marker-primary]')
      const center = new maps.LatLng(
        mapMarkerPrimary.getAttribute('data-map-marker-lat'),
        mapMarkerPrimary.getAttribute('data-map-marker-lng'),
      );

      this.map = new maps.Map(this.$refs.map, {
        zoom: DEFAULT_ZOOM,
        center,
        mapTypeId: maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        fullscreenControl: false,
        scaleControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        zoomControl: false,
      })

      this.markers = Array.from(this.$el.querySelectorAll('[data-map-marker]'))
      this.selected = parseInt(mapMarkerPrimary.getAttribute('data-map-marker-id'), 10)
    },

    addMapMarkers() {
      const { map, maps } = this

      this.markers.forEach((location) => {
        const marker = new maps.Marker({
          map,
          position: new maps.LatLng(
            location.getAttribute('data-map-marker-lat'),
            location.getAttribute('data-map-marker-lng'),
          ),
        })

        location.addEventListener('click', () => {
          map.setZoom(DEFAULT_ZOOM)
          map.setCenter(marker.getPosition())

          this.selected = parseInt(location.getAttribute('data-map-marker-id'), 10)
        })
      })
    },

    marker: {
      ['x-bind:class']() {
        return this.selected === parseInt(this.$el.getAttribute('data-map-marker-id'), 10) ? 'border-l-tpnblue-800 bg-tpnblue-50' : 'border-l-transparent'
      },
    },
  }
}

export default { create }
